import React, { useEffect, useState } from 'react';
import {
  ButtonPrimary,
  IconBadgeAccount,
  Input,
} from '@skf/bt-wind-rail-commonlibrary';
import style from './RoleManagementList.module.scss';
import { useTranslation } from 'react-i18next';
import { useLoadingScreen } from '../../../../hooks/useLoadingScreen';
import { Role } from '../../../../store/roles/types';
import RoleManagementListDataTable from './dataTable/RoleManagementListDataTable';
import { useDispatch, useSelector } from 'react-redux';
import { fetchRoles } from '../../../../store/roles/actions';
import { StoreState } from '../../../../store/store';
import { IRolesState } from '../../../../store/roles/store';
import { getOrderedRoles } from './RoleManagementList.mapper';
import { usePathname } from '../../../../hooks/usePathname';
import {
  RoleManagementAddRoleRoute,
  RoleManagementEditRoleRoute,
  UserManagementRoute,
} from '../../../../routes/routes';
import { generatePath } from 'react-router';
import { IUserSettingsState } from '../../../../store/userSettings/store';
import { isUserAuthorized } from '../../../../services/authentication/authenticationService';
import { UserWebFeatures } from '../../../../store/userSettings/types';

interface IUserManagementListProps {}

const RoleManagementList: React.FunctionComponent<IUserManagementListProps> = () => {
  const { t } = useTranslation();
  const { setLoading } = useLoadingScreen();
  const dispatch = useDispatch();
  const { setPathname } = usePathname();

  const userSettings: IUserSettingsState = useSelector<
    StoreState,
    IUserSettingsState
  >((state) => state.userSettings);

  useEffect(() => {
    const authorized = isUserAuthorized(userSettings, [
      UserWebFeatures.ROLE_MANAGEMENT_ACCESS,
    ]);
    if (authorized) setPathname(UserManagementRoute.path);
  }, [userSettings, userSettings.isFetching]);

  const { roles }: IRolesState = useSelector<StoreState, IRolesState>(
    (state) => state.roles
  );

  const [filteredRoles, setFilteredRoles] = useState<Role[]>([]);

  useEffect(() => {
    dispatch(fetchRoles());
  }, []);

  useEffect(() => {
    if (!roles) return;
    setFilteredRoles(getOrderedRoles(roles));
    setLoading(false);
  }, [roles]);

  const onAddRole = () => {
    setPathname(RoleManagementAddRoleRoute.path);
  };

  const onEditRole = (role: Role) => {
    setPathname(
      generatePath(RoleManagementEditRoleRoute.path, { roleName: role.name })
    );
  };

  const onChangeSearch = (text: string) => {
    if (!roles) return;
    setFilteredRoles(
      roles?.filter(
        (role) =>
          JSON.stringify(role).toLowerCase().indexOf(text.toLowerCase()) > -1
      )
    );
  };

  return (
    <>
      <div className={style.actionRow}>
        <ButtonPrimary className={style.actionButton} onClick={onAddRole}>
          <IconBadgeAccount />
          <a>{t('Add_Role')}</a>
        </ButtonPrimary>
      </div>
      <Input
        className={style.inputSearch}
        placeholder={`${t('Search')}...`}
        onChange={onChangeSearch}
      />
      <RoleManagementListDataTable
        roles={filteredRoles}
        onEditRole={onEditRole}
      />
      {/*{*/}
      {/*  userToDelete && (*/}
      {/*    <UserManagementDelete*/}
      {/*      user={userToDelete}*/}
      {/*      onClose={onUserManagerDeleteClose}*/}
      {/*    />*/}
      {/*  )*/}
      {/*}*/}
    </>
  );
};

export default RoleManagementList;
